var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:[_vm.color, _vm.direction],attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"8","viewBox":"0 0 14 8"}},[_c('path',{staticClass:"a",attrs:{"d":"M12.6,0,7,5.333,1.4,0,0,1.333,7,8l7-6.667Z","transform":"translate(0 0)"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }